import { ref, watch } from 'vue';
import type { PageMetafieldsPreviewTarget } from '../utils/metafieldsPreviewUrl';

const STORAGE_KEY = 'shopexperts.admin-pages-editor.preview-target';

function readStoredTarget(): PageMetafieldsPreviewTarget {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'beta' || stored === 'live' ? stored : 'live';
  } catch {
    return 'live';
  }
}

/**
 * Module-level so the live/beta choice is shared across every page opened in
 * the editor, and persisted so it survives reloads.
 */
const previewTarget = ref<PageMetafieldsPreviewTarget>(readStoredTarget());

watch(previewTarget, (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage can be unavailable (private mode, quota) — the in-memory value still applies.
  }
});

export function usePreviewTargetPreference() {
  return previewTarget;
}
